// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Y23d","checkboxCol":"Table_checkboxCol__3nNCz","emailCol":"Table_emailCol__1tTWg","actionCol":"Table_actionCol__3AN-Y"};